import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const EditPencilGlyph = /*#__PURE__*/createElement("g", {
  id: "edit_pencil",
  fill: "none",
  style: {
    transform: 'scale(6)'
  }
}, /*#__PURE__*/createElement("path", {
  d: "M11.6094 5.86782L8.61177 2.91124M1 13.5L4.9666 12.2722C5.11991 12.2248 5.25955 12.1411 5.37372 12.0283L13.1421 4.35354C13.3394 4.15863 13.3404 3.8404 13.1443 3.6443L10.8557 1.3557C10.6596 1.1596 10.3414 1.16057 10.1465 1.35785L2.47164 9.12623C2.35884 9.2404 2.27518 9.38004 2.22772 9.53336L1 13.5Z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
const EditPencil = createSvg({
  name: 'edit_pencil',
  path: EditPencilGlyph
});

export default EditPencil;
export { EditPencilGlyph };
